import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import store from '../store/index';
Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
		meta: {
			requiresAuth: true,
			// permission: 'login.web',
		},
	},
	/*{
		path: '/:tenant/',
		name: 'Login',
		component: Login,
	},*/
	{
		path: '/about',
		name: 'About',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
		meta: {
			requiresAuth: true,
			// permission: 'users.delete',
		},
	},
	{
		path: '/admins',
		name: 'Administrators',
		component: () => import(/* webpackChunkName: "users" */ '../modules/admins/views/Admins.vue'),
		meta: {
			requiresAuth: true,
			// permission: 'users.read',
		},
	},
	{
		path: '/tenants',
		name: 'Tenants',
		component: () => import(/* webpackChunkName: "users" */ '../modules/tenants/views/Tenants.vue'),
		meta: {
			requiresAuth: true,
			// permission: 'users.read',
		},
	},
	{
		path: '/adapterRuns',
		name: 'AdapterRuns',
		component: () => import(/* webpackChunkName: "users" */ '../modules/adapterRuns/views/AdapterRuns.vue'),
		meta: {
			requiresAuth: true,
			// permission: 'roles.read',
		},
	},
	{
		path: '/apiKeys',
		name: 'APIKeys',
		component: () => import(/* webpackChunkName: "users" */ '../modules/API-Keys/views/APIKeys.vue'),
		meta: {
			requiresAuth: true,
			// permission: 'roles.read',
		},
	},
	{
		path: '/adapters',
		name: 'Adapters',
		component: () => import(/* webpackChunkName: "users" */ '../modules/adapters/views/AdapterStatus.vue'),
		meta: {
			requiresAuth: true,
			// permission: 'roles.read',
		},
	},
	{
		path: '/login',
		name: 'Login',
		component: () => import('../views/Login.vue'),
		meta: {
			guest: true,
		},
	},
	{
		path: '/passwordResetRequest',
		name: 'Password Reset Request',
		component: () => import('../views/PasswordResetRequest.vue'),
		meta: {
			guest: true,
		},
	},
	{
		path: '/passwordReset',
		name: 'Password Reset',
		component: () => import('../views/PasswordReset.vue'),
		meta: {
			guest: true,
		},
	},
	{
		path: '/meinProfil',
		name: 'MeinProfil',
		component: () => import('../modules/profil/views/MeinProfil.vue'),
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/passwordChange',
		name: 'PasswortÄndern',
		component: () => import('../views/ChangePassword.vue'),
		meta: {
			requiresAuth: true,
		},
	},
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
});

export async function beforeEach(to, from, next) {
	if (to.matched.some((record) => record.meta.requiresAuth)) {
		await store.dispatch('auth/getToken');
		await store.dispatch('auth/load');
		if (store.getters['auth/isLoggedIn']) {
			next();
		} else {
			next('/login');
		}
	} else if (to.matched.some((record) => record.meta.guest)) {
		if (store.getters['auth/isLoggedIn']) {
			next('/');
		} else {
			next();
		}
	}
}

router.beforeEach((to, from, next) => beforeEach(to, from, next));

export default router;
